import PortfolioMobile from 'components/PortfolioMobile';
import Portfolio from '../../components/Portfolio/index';
import { DataGood } from '../../components/Portfolio/data';

export default function GoodStorage() {
  return (
    <>
      <div className="d-none d-lg-block">
        <Portfolio data={DataGood} />
      </div>
      <div className="d-block d-lg-none">
        <PortfolioMobile data={DataGood} />
      </div>
    </>
  );
}
